export const educationData = [
    
    {
        id: 1,
        institution: 'Addis Ababa University',
        course: 'BSc. Software Engineering',
        startYear: '2023',
        endYear: '2027'
    },
    // {
    //     id: 2,
    //     institution: 'Miskaye Hizunan Medhanealem Monastry School',
    //     course: 'Higher Secondary Education',
    //     startYear: '2019',
    //     endYear: '2022'
    // },
]